<div matDialogTitle i18n>Upload Document</div>
<mat-dialog-content>
    <input #fileInput hidden type="file" [accept]="accept" (change)="selectFile($event)">

    @if (!file) {
        <div class="drop-target" (dragover)="dragOver($event)" (drop)="drop($event)" (click)="fileInput.click()">
            <div i18n>Drop file here or click to choose a file.</div>
            <div class="hint" i18n>Accepted formats: PDF, PNG, JPG, JPEG.</div>
        </div>
    } @else {
        <div class="file-details">
            <div><strong i18n>File:</strong> {{ file.name }}</div>
            <div><strong i18n>Type:</strong> {{ file.type || 'unknown' }}</div>
            <div><strong i18n>Size:</strong> {{ file.size }} bytes</div>
            <button mat-button (click)="fileInput.click()" [disabled]="uploading" i18n>Change File</button>
        </div>
    }

    <mat-form-field class="w-full mt-4">
        <mat-label i18n>Document Type</mat-label>
        <mat-select [(value)]="type" [disabled]="uploading">
            @for (choice of documentTypes; track choice) {
                <mat-option [value]="choice.value">{{ choice.label }}</mat-option>
            }
        </mat-select>
    </mat-form-field>

    @if (uploading) {
        <div class="progress-wrapper">
            <mat-progress-bar mode="determinate" [value]="uploadProgress"></mat-progress-bar>
            <div class="progress-label">{{ uploadProgress }}%</div>
        </div>
    }

    @if (error) {
        <div class="error">{{ error }}</div>
    }
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()" [disabled]="uploading" i18n>Cancel</button>
    <button matButton="filled" (click)="upload()" [disabled]="!canUpload()">
        <span i18n>Upload</span>
    </button>
</mat-dialog-actions>
